import { render } from "./shutdownRecord.vue?vue&type=template&id=d8622636&scoped=true"
import script from "./shutdownRecord.vue?vue&type=script&lang=js"
export * from "./shutdownRecord.vue?vue&type=script&lang=js"

import "./shutdownRecord.vue?vue&type=style&index=0&id=d8622636&scoped=true&lang=css"
import "./shutdownRecord.vue?vue&type=style&index=1&id=d8622636&lang=css"
script.render = render
script.__scopeId = "data-v-d8622636"

export default script